import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Combobox } from '@flywire/react-headlessui';
import { useLabelClasses } from '../Field';
import { useComboboxContext } from './Combobox';
const LabelComponent = forwardRef(({ className, ...rest }, ref) => {
    const { floatingLabel } = useComboboxContext();
    const labelClasses = useLabelClasses({ floatingLabel, className });
    return _jsx(Combobox.Label, { className: labelClasses, ref: ref, ...rest });
});
LabelComponent.displayName = 'Label';
const Label = LabelComponent;
export { Label };
//# sourceMappingURL=Label.js.map